import { screen } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'container',
  label: 'Screen',
  category: 'Layouts',
  image: screen
};
